import { AppConstants } from '../app.constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {TipModel} from '../model/spring-model/tip.model';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class TipService {

  constructor(private https: HttpClient, private  authService: AuthenticationService) { }
  getTipByModelS(modelId: number): Observable<HttpResponse<TipModel[]>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'tip/model/' + modelId;
    return this.https.get<TipModel[]>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/tip.service.ts